export enum BaseFieldType {
    FIELD_CALCULATED = 'FIELD_CALCULATED',
    FIELD_IMAGE = 'FIELD_IMAGE',
    FIELD_NUMBER = 'FIELD_NUMBER',
    FIELD_PROFILE = 'FIELD_PROFILE',
    FIELD_REFERENCE = 'FIELD_REFERENCE',
    FIELD_STRING = 'FIELD_STRING',
    FIELD_TEXT = 'FIELD_TEXT',
}
